import { createContext } from "react";

const DocumentsContext = createContext();

export default DocumentsContext;